import { Link, useLocation } from "react-router-dom";
import { SidebarMenuSubButton, SidebarMenuSubItem } from "@altimateai/lego";
import { BetaTag } from "@/components/tags";

interface SidebarSubLinkProps {
  to: string;
  label: string;
  isBeta?: boolean;
}

export const SidebarSubLink = ({ to, label, isBeta }: SidebarSubLinkProps) => {
  const { pathname } = useLocation();
  const isActive = pathname.startsWith(to);

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        isActive={isActive}
        className="al-px-3 !al-text-muted-foreground [&>svg]:al-size-5 data-[active=true]:!al-text-brand"
      >
        <Link to={to} state={{ breadcrumbReset: true }}>
          <span className="al-whitespace-nowrap">{label}</span>
          {isBeta && <BetaTag />}
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
};
